import { render, staticRenderFns } from "./ContentsList.vue?vue&type=template&id=a60c944c&scoped=true&"
import script from "./ContentsList.vue?vue&type=script&lang=js&"
export * from "./ContentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60c944c",
  null
  
)

export default component.exports